import styled from 'styled-components';

const WarningMessage = styled.div`
  background: #fff5e6;
  border: 1px solid #ff9800;
  border-radius: 3px;
  min-height: 28px;
  text-align: center;
  padding: 4px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  font-family: 'Roboto';
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;

export default WarningMessage;
